import CompareCards from 'components/Products/Lenses/S-Mount/Lense_Comparison/lense-compare-cards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  CompareCards,
  BreadCrumbs,
  SEOHelmet,
  React
};